const PREDECESSOR_OPERATION = 'REACCOMMODATE';

const findConstPriceInLinkedObjects = (bookingItems, itemIds) => {
  const fondedItem = bookingItems.find(({ id }) => itemIds.includes(id));

  if (fondedItem) {
    let itemCostPrice = fondedItem?.costPriceInItemCurrency?.amount;

    if (itemCostPrice) {
      return itemCostPrice;
    } else if (fondedItem?.predecessorInfo?.operation === PREDECESSOR_OPERATION && fondedItem?.predecessorInfo?.itemIds) {
      itemCostPrice = findConstPriceInLinkedObjects(bookingItems, fondedItem.predecessorInfo.itemIds);
    }
  }

  return;
};

const getCostPriceForBookingItems = (bookingItems, products, productPrice, productUUID, productAssociatedItemRefs) => {
  const associatedProduct = products.find(({ itemRef }) => productAssociatedItemRefs.includes(itemRef));
  const associatedBookingItem =
    productPrice > 0 ? bookingItems.find(({ id }) => id === productUUID) : bookingItems.find(({ id }) => id === associatedProduct.uuid);

  let itemCostPrice = associatedBookingItem?.costPriceInItemCurrency?.amount;

  if (itemCostPrice) {
    return productPrice > 0 ? itemCostPrice : +(associatedProduct.price - itemCostPrice).toFixed(2);
  } else {
    if (associatedBookingItem?.predecessorInfo?.operation === PREDECESSOR_OPERATION) {
      const itemIds = associatedBookingItem?.predecessorInfo?.itemIds ?? [];

      itemCostPrice = findConstPriceInLinkedObjects(bookingItems, itemIds);

      if (itemCostPrice) {
        return productPrice > 0 ? itemCostPrice : +(associatedProduct.price - itemCostPrice).toFixed(2);
      } else {
        return productPrice;
      }
    } else {
      return productPrice;
    }
  }
};

export default getCostPriceForBookingItems;
